import React from "react";

// Shared Time-filter (This Month / Last Month / 3 Months / Custom) used by the
// DSE dashboard, Physio Master and Physio Report.
export const PRESETS = [
  { id: "this_month", label: "This Month" },
  { id: "last_month", label: "Last Month" },
  { id: "3_months", label: "3 Months" },
  { id: "custom", label: "Custom" },
];

function ymd(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function periodRange(preset, customStart, customEnd) {
  const today = new Date();
  if (preset === "this_month") {
    return { start: ymd(new Date(today.getFullYear(), today.getMonth(), 1)), end: ymd(today) };
  }
  if (preset === "last_month") {
    const s = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const e = new Date(today.getFullYear(), today.getMonth(), 0);
    return { start: ymd(s), end: ymd(e) };
  }
  if (preset === "3_months") {
    return { start: ymd(new Date(today.getFullYear(), today.getMonth() - 2, 1)), end: ymd(today) };
  }
  if (preset === "custom") {
    return { start: customStart || "", end: customEnd || "" };
  }
  return { start: "", end: "" };
}

export function TimeFilter({ preset, setPreset, customStart, setCustomStart, customEnd, setCustomEnd, testId = "time-filter", label = "Time" }) {
  return (
    <div className="surface p-3 flex flex-wrap items-center gap-2" data-testid={testId}>
      <span className="small-caps text-slate-500 mr-1">{label}</span>
      {PRESETS.map((p) => (
        <button
          key={p.id}
          onClick={() => setPreset(p.id)}
          data-testid={`time-filter-${p.id}`}
          className={`text-[12.5px] px-3 py-1.5 rounded-full border transition-colors ${preset === p.id ? "border-teal-700 bg-teal-50 text-teal-900" : "border-slate-200 text-slate-600 hover:bg-slate-50"}`}
        >
          {p.label}
        </button>
      ))}
      {preset === "custom" && (
        <div className="flex items-center gap-2 ml-1">
          <input type="date" value={customStart} onChange={(e) => setCustomStart(e.target.value)} className="text-[12.5px] py-1.5" data-testid="time-filter-custom-start" />
          <span className="text-slate-400 text-[12px]">to</span>
          <input type="date" value={customEnd} onChange={(e) => setCustomEnd(e.target.value)} className="text-[12.5px] py-1.5" data-testid="time-filter-custom-end" />
        </div>
      )}
    </div>
  );
}
